angular.module('zc.zenclerkS')
  .component('zcsProjectSettings', {
    templateUrl: '/templates/zenclerk_s/sites/settings/project_settings.html',
    bindings: {
      project: '='
    },
    controllerAs: 'vm',
    controller: ZcsProjectSettingsController,
  });

ZcsProjectSettingsController.$inject = ['$scope', '$rootScope', 'AccessStats', 'Devise', 'ZcsImage', 'ZcsProject', 'currencies', 'Meta'];
function ZcsProjectSettingsController($scope, $rootScope, AccessStats, Devise, ZcsImage, ZcsProject, currencies, Meta) {
  const vm = this;

  vm.currency = currencies[vm.project.currency];

  // variables
  vm.avgPayment = undefined;
  vm.profitRateOptions = ZcsProject.PROFIT_RATE_OPTIONS();
  vm.isSaving = false;
  vm.canEditCurrencies = canEditCurrencies;
  vm.regions = [];
  vm.dashboardCurrencies = [];
  Meta.getRegions().then(res => (vm.regions = res));
  Meta.getCurrencies().then(res => (vm.dashboardCurrencies = res));
  // actions
  vm.saveProject = saveProject;

  activate();

  $scope.$watch('vm.project.site_logo_image_id', function(imageId) {
    if(!imageId) return;
    ZcsImage.get({
      projectId: vm.project.id,
      imageId: imageId
    })
      .then(image => {
        vm.project.site_logo_image_url = image.image_url;
      });
  });

  function activate() {
    AccessStats.find({
      dimension: 'daily',
      apikey: vm.project.apikey,
    }, {
      match: {
        campaign_segment_id: null,
        is_control: null,
        device: null,
        start_at: { $gte: moment().subtract(4, 'days').toDate() }
      }
    }).then(res => {
      if(res.length > 0) {
        vm.avgPayment = res[0].conversion_price / res[0].conversion_count;
      }
    });
  }

  function saveProject(project) {
    vm.isSaving = true;
    ZcsProject.saveProject(project).then(res => {
      vm.project = _.merge(vm.project, res);
      $rootScope.$emit('projectUpdated', vm.project);
    })
      .finally(() => {
        vm.isSaving = false;
        vm.currency = currencies[vm.project.currency];
        $scope.siteSettings.$setPristine();
      });
  }

  function canEditCurrencies() {
    if(Devise.isMaster()) return true;
    if(Devise.currentUser.agency_id &&
       Devise.currentUser.agency_id === vm.project.agency_id) return true;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/settings/project_settings.js